export const RouteConfig = {
  signIn: '/signin',
  passwordReset: '/signin/password-reset',
  main: '/',
  initialSetup: '/dados-empresa',
  signup: '/signup',
};
